import React, { Component } from 'react';
// import axios from 'axios';
import {get, post, put, del} from '../../DAL/Request'
import { Table, Button } from 'antd';
import CaseEditorForm from './CaseEditorForm';
import config from '../../dummy_data/configuration.json';
import PropTypes from "prop-types";


const emptyItem = {
	ID: 0,
  	Title: '',
  	Thumbnail: '',
  	Content: '',
  	PlainText: '',
  	Available: true,
  	Created: '',
  	Modified: ''
};

class CaseManager extends Component {
	static contextTypes = {
		router: PropTypes.object
	}

	constructor(props, context) {
	    super(props, context);
	    this.columns = [
			{
			    title: 'Action',
			    key: 'operation',
			    // fixed: 'left',
			    width: 100,
			    render: (text, record) => <div><a stlye={{float: 'left'}} onClick={() => this.handleEditModal(record.ID)}>Edit</a><a style={{float: 'right'}} onClick={() => this.handleDeleteModal(record.ID)}>Delete</a></div>
		  	},
		  	{ title: 'Title', width: 100, dataIndex: 'Title', key: 'Title' },
		  	{ 
		  		title: 'Thumbnail', 
		  		width: 200, 
		  		dataIndex: 'Thumbnail', 
		  		key: 'Thumbnail',
		  		render: (text, record) => <a href={record.Thumbnail} target="_blank">Click to link to the image</a>
		  	},
		  	{ 
		  		title: 'Available', 
		  		width: 100, 
		  		dataIndex: 'Available', 
		  		key: 'available',
		  		render: (text, record) => <span style={{'width': '20px', 'height': '20px', 'display': 'block', 'borderRadius': '100%', 'backgroundColor': record.Available? '#1890ff' : '#ccc'}}></span>
		  	}
		];
		

	    this.state = {
			visible: false,
			newsItems: [],
			editingItem: emptyItem
		}
  	}

  	componentWillMount() {
  		this.handleRefreshData();
  	}
	

	showModal = () => {
		this.handleShowHideModal(true);
	}

	handleEditModal = (id) => {
		// console.log(this.state.editingItem);
		const target = this.state.newsItems.filter(item => item.ID === id);
		// console.log(target);
		if(target && target.length > 0){
			this.setState({ editingItem: target[0] });
			this.handleShowHideModal(true);
		}
	}
	handleDeleteModal = (key) => {
		// console.log(this.state.editingItem);
		// axios({
		// 	method: 'delete',
		// 	url: `${config.caseItemsAction}/${key}`,
		// 	responseType:'json'
		// }).then(res => {
		// 	console.log("response", res);
		// 	this.handleRefreshData();
		// }).catch(function (error) {
		// 	console.log(error);
		// });
		del({
  			url: `${config.caseItemsAction}/${key}`, 
  			history: this.context.router.history,
  			callback: (res) => {
  				console.log("response", res);
				this.handleRefreshData();
  			}
  		});
	}
	handleShowHideModal(visible){
		this.setState({ visible: visible });

		if(!visible){
			this._resetEditingItem();
		}
	}

	handleUpdateImageUrl = (url) => {
		let currentItem = this.state.editingItem;
		currentItem.Thumbnail = url;
		this.setState({ editingItem: currentItem });
	}

	handleRefreshData = () => {
		// axios.get(config.caseItemsAction).then((res)=>{
  //           // console.log(res);
  //           this.setState({
  //           	newsItems: res.data
  //           });
  //       }).catch((err)=>{
  //           console.log(err.status);
  //       })
        get({
  			url: config.caseItemsAction, 
  			history: this.context.router.history,
  			callback: (res) => {
  				this.setState({
	            	newsItems: res.data
	            });
  			}
  		});
	}

	_resetEditingItem(){
		this.setState({ 
			editingItem: emptyItem
		});
	}

	
	render() {
		return (
			<div>
				<Button type="primary" onClick={this.showModal}>
			      	Add new item
			    </Button>
				<div className="">
					<Table bordered columns={this.columns} dataSource={this.state.newsItems} rowKey="ID" />
					<CaseEditorForm 
						visible={this.state.visible} 
						item={this.state.editingItem} 
						handleShowHideModal={this.handleShowHideModal.bind(this)} 
						handleUpdateImageUrl={this.handleUpdateImageUrl} 
						handleRefreshData = {this.handleRefreshData}
					/>
				</div>
		  	</div>
		);
	}
}

export default CaseManager;


// WEBPACK FOOTER //
// ./src/components/admin/CaseManager.js